export const animations = {
  idleLoop: new URL('./idle_loop.vrma', import.meta.url),
}
